import React from 'react';
import globalVariable from '../../../GlobalVariable';

const Footer = () => {
    return (
        <footer className="bg-gray-900 text-white py-12">
            <div className="container mx-auto px-6">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
                    <div>
                        <img src={globalVariable.logo} alt="Azúcar Multimedia" className="h-12 mb-4" />
                        <p className="text-gray-400">
                            Creativity and technology to boost your brand.
                        </p>
                    </div>

                    <div>
                        <h4 className="text-lg font-bold mb-4">Quick Links</h4>
                        <ul className="space-y-2">
                            <li><a href="#servicios" className="text-gray-400 hover:text-red-500 transition duration-300">Services</a></li>
                            {/* <li><a href="#portafolio" className="text-gray-400 hover:text-red-500 transition duration-300">Portafolio</a></li> */}
                            <li><a href="#clientes" className="text-gray-400 hover:text-red-500 transition duration-300">Clients</a></li>
                            <li><a href="#contacto" className="text-gray-400 hover:text-red-500 transition duration-300">Contact</a></li>
                        </ul>
                    </div>

                    <div>
                        <h4 className="text-lg font-bold mb-4">Contact</h4>
                        <p className="text-gray-400 mb-2" href="mailto:info@azucarmultimedia.com">info@azucarmultimedia.com</p>
                        <p className="text-gray-400" href="tel:+1-408-509-0579">+1-408-509-0579</p>
                    </div>
                </div>

                <div className="border-t border-gray-800 pt-8 text-center text-gray-400">
                    <p>&copy; {new Date().getFullYear()} Azúcar Multimedia. All rights reserved.</p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;